import { render, staticRenderFns } from "./import.vue?vue&type=template&id=08f0c4c6&scoped=true"
import script from "./import.vue?vue&type=script&lang=ts"
export * from "./import.vue?vue&type=script&lang=ts"
import style0 from "./import.vue?vue&type=style&index=0&id=08f0c4c6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0c4c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f0c4c6')) {
      api.createRecord('08f0c4c6', component.options)
    } else {
      api.reload('08f0c4c6', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=08f0c4c6&scoped=true", function () {
      api.rerender('08f0c4c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventorySystemManagement/inventoryQuery/import.vue"
export default component.exports